import React from 'react';
import './LogoAnimation.css';

export default function LogoAnimation() {
  return (
    <div className="logo-animation-wrapper">
      <h1 className="hw-name" aria-label="Le Chalet des Flandres">
        <span className="hw-text">Le Chalet des Flandres</span>
        <span className="hw-underline" aria-hidden="true" />
      </h1>
    </div>
  );
}
